<template>
  <div class="fill-height">


    <v-card class="fill-height">

      <v-toolbar dense dark style="display: block"  color="#1e45c7" >
        <v-toolbar-title>پیام های ارسالی </v-toolbar-title>
        <v-spacer/>
        <v-btn dark depressed small style="background-color: #be1e0b" icon @click="closed">
          <v-icon >mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12"
                 sm="12"
                 md="4"
                 class="d-inline-flex">
            <v-text-field
                outlined
                dense
                clearable
                @click:clear="clearSearch"
                placeholder="نام واحد یا نام مجتمع"
                v-model="searchvalue"
            />
            <v-btn  fab small color="primary" @click="fillDataItems" class="mr-1">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>

          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="8" class="d-inline-block">

            <b-pagination
                v-model="skip"
                :total-rows="paging.totalSize"
                :per-page=take
                first-text="اولین"
                prev-text="<"
                next-text=">"
                last-text="آخرین"
                dir="ltr"
                limit="5"
                @change="pageChangeHandler"
            />

          </v-col>


        </v-row>

        <b-table
            v-if="can('messageList')"
            :items="dataItems"
            :fields="columns"
            :current-page="skip"
            :per-page=0
            stacked="md"
            show-empty
            responsive striped
        >
          <template #cell(actions)="row" v-if="can('editMessage') || can('deleteMessage') ">
            <v-btn depressed class="mr-1" v-if="can('deleteMessage')" small color="error" @click="remove(row.item)">
              حذف
            </v-btn>
          </template>
        </b-table>


      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import Message_se from "./Message_se";


export default {
  name: 'DetailMsg',
  data() {
    return {
      searchvalue:'',
      dataItems: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      id:'',
      columns: [
        {key: 'title', label: 'عنوان', sortable: true, sortDirection: 'desc'},
        {key: 'dateText', label: 'تاریخ ارسال' },
        {key: 'receiverName', label: 'نام شخص' },
        {key: 'buildingName', label: 'نام مجتمع'},
        {key: 'actions', label: 'عملیات'},
      ],


    };

  },



  methods: {
    fillDataItems: function (id) {
      Message_se.detailMsg(this.skip - 1, this.take, id,this.searchvalue).then(res=>{
        this.dataItems=res.data.messageList
        this.paging=res.data.page
      })
    },

    closed() {
      this.dataItems=[]
      this.$root.$emit('Message' )
      this.$router.go(-1);
    },
    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems(this.id);

    },
    clearSearch(){
      this.searchvalue=''
      this.fillDataItems(this.id);
    },

    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              Message_se.delete(e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems(this.id);
                } else {
                  this.$snack({type: 'error'})
                }
              })
          )
    },
  },

  created() {
    this.id=this.$route.query.id
    this.fillDataItems(this.id);
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
